import Cookies from 'js-cookie'
import { GQLConfig } from '~/graphql/__generated__/interfaces'

export function isFeatureEnabled(featureId: string, getConfig: GQLConfig) {
  return !!getFeatureValue(featureId, getConfig)
}

/**
 * Get feature value. Allows to overwrite the value from global config via cookie. This is handy for local development.
 */
export function getFeatureValue(featureId: string, getConfig: GQLConfig) {
  const allFeaturesList = getConfig.featureFlags || {}
  const cookieValue = Cookies.get(featureId)
  return cookieValue ?? allFeaturesList[featureId]
}
